import { clientIsDesktop, useAPI } from "../../../lib/common";
import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Skeleton } from "@material-ui/lab";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import useRoutes, { getLinkComponentAttributes } from "../../hooks/useRoutes";
const useStyles = makeStyles((theme) => {
    return {
        categoriesList: {
            listStyle: "none",
            margin: 0,
            padding: 0,
            overflow: "auto",
            whiteSpace: "nowrap",
            marginBottom: theme.spacing(2),
            "& > li": {
                display: "inline-block",
                marginLeft: theme.spacing(2),
            },
            "& > li:last-child": {
                marginRight: theme.spacing(2),
            },
            "&$categoriesListWithScrollBar": {
                paddingBottom: "10px",
            },
        },
        categoriesListWithScrollBar: {},
        categoryButton: {
            paddingTop: "6px",
            paddingBottom: "6px",
            // Why does this need to be written like this?
            "&.MuiButton-root": {
                borderRadius: "4px",
            },
        },
    };
});
const CardCategories = ({ handleChangeCategory, category, }) => {
    const [data, loading] = useAPI(`/m/api/templates/cards/categories`);
    const listRef = useRef(null);
    const classes = useStyles();
    const scrollBars = clientIsDesktop() &&
        listRef.current &&
        listRef.current.scrollWidth > listRef.current.clientWidth;
    return (React.createElement("ul", { className: `${classes.categoriesList} ${scrollBars ? classes.categoriesListWithScrollBar : ""}`, ref: listRef }, loading || !data ? (React.createElement(CardCategoriesSkeleton, null)) : (React.createElement(CardCategoriesList, { listRef: listRef, categories: data.categories, category: category }))));
};
export default CardCategories;
const CardCategoriesList = ({ categories, category, listRef, }) => {
    const [t] = useTranslation();
    const translatedCategories = categories
        .map((category) => {
        return {
            internalName: category,
            name: t(category),
        };
    })
        .sort((a, b) => {
        return a.name.localeCompare(b.name);
    });
    return (React.createElement(React.Fragment, null, translatedCategories.map((cat) => {
        return (React.createElement("li", { key: cat.internalName },
            React.createElement(CardCategory, { category: cat, selected: cat.internalName == category, listRef: listRef })));
    })));
};
const CardCategoriesSkeleton = () => {
    const numCategories = Array.from(Array(5).keys());
    return (React.createElement(React.Fragment, null, numCategories.map((i) => {
        return (React.createElement("li", { key: i },
            React.createElement(Skeleton, { variant: "rect", width: 100, height: 34 })));
    })));
};
const CardCategory = ({ category, selected, listRef }) => {
    const ref = useRef(null);
    const classes = useStyles();
    const routes = useRoutes();
    useEffect(() => {
        if (selected && (ref === null || ref === void 0 ? void 0 : ref.current) && (listRef === null || listRef === void 0 ? void 0 : listRef.current)) {
            const width = window.innerWidth;
            const size = ref.current.getBoundingClientRect();
            const left = ref.current.offsetLeft - width / 2 + size.width / 2;
            listRef.current.scrollLeft = left;
        }
    }, [selected]);
    const link = getLinkComponentAttributes({
        path: "products.cards.category",
        variables: {
            type: "cards",
            category: category.internalName,
        },
    }, routes, true);
    return (React.createElement(Button, Object.assign({ ref: ref, variant: "contained", size: "small", classes: { root: classes.categoryButton }, color: selected ? "secondary" : "primary" }, link), category.name));
};
